import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';

import {
  PrinterReferenceService,
  PrinterService,
  TmsFormlyService,
  UserPrinter,
  UserPrinterService,
} from '../../../../app-shared';
import { BaseComponent, BaseEditFormModalComponent, IdDescription } from '../../../../tms-shared';
import { UserService } from '../../services';

@Component({
  selector: 'app-user-printers-create-modal',
  templateUrl: './user-printers-create-modal.component.html',
  styleUrl: './user-printers-create-modal.component.scss',
})
export class UserPrintersCreateModalComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseEditFormModalComponent) form: BaseEditFormModalComponent;

  @Input() id: string;
  @Input() model: UserPrinter;
  @Input() userId: string;

  fields: FormlyFieldConfig[];

  private printers$: Observable<IdDescription[]>;

  constructor(
    public userPrinterService: UserPrinterService,
    private printerReferenceService: PrinterReferenceService,
    private printerService: PrinterService,
    private userService: UserService,
    private formlyService: TmsFormlyService,
  ) {
    super();
  }

  ngOnInit() {
    this.getReferenceData();
    this.getFields();
  }

  private getReferenceData() {
    this.printers$ = this.printerReferenceService.get();
  }

  private getFields() {
    this.fields = this.formlyService.oneColumnGrid([
      this.formlyService.select('printerId', $localize`Printer`, this.printers$, undefined, { required: true }),
    ]);
  }

  saved() {
    this.userService.refreshDetails.next();
  }
}
